<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
        <div class="row p-1">
            <div class="mt-3 col-12">
                <FormInput label="Número de usos por código" type="number" name="usos" id="usos" rules="required" v-model="usos" />
            </div>
            <div class="col-12">
                <button type="submit" id="generar_codigos" class="btn btn-primary mb-3" target="blank">Guardar</button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['usos'],
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.$emit('terminado', this.usos);
                }
            }
        }
    }
</script>